import { Button, Empty } from "antd";
import { ContentFilters, ContentTopBar, Loader } from "components";
import { ResultError } from "components/errors";
import {
  MainFilters,
  // MainFiltersOptions,
  MainFiltersParams,
} from "components/main-filters/main-filters";
// import { useMainFiltersContext } from 'components/main-filters/main-filters.context';
import dayjs from "dayjs";
import {
  EmptyStateWrapper,
  StyledTimetableBackground,
  TimetableContainer,
  WeekViewFiltersForm,
  WeekViewFiltersFormValues,
} from "features/bookings/components";
import { WeekTimetable } from "features/bookings/components/fields-timetable/week-timetable";
import { SportList } from "features/bookings/components/sport-list/sport-list";
import { useGetFieldBookings } from "features/bookings/use-cases/get-field-booking";
import { FieldBookingsParams } from "features/fields";
import { usePermissions } from "features/users";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  // useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "utils/date";

export type WeekViewParams = FieldBookingsParams & MainFiltersParams;
const initialParams: WeekViewParams = {
  date: formatDate({
    date: dayjs().weekday(0),
    format: "isoDate",
  }),
  id: undefined,
  sport_id: undefined,
  field_id: undefined,
};

export const WeekView = () => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const [selectedFieldTitle, setSelectedFieldTitle] = useState("");

  const timetableRef = useRef<HTMLDivElement>(null);
  const [componentTopOffset, setComponentTopOffset] = useState(0);
  const [zoomLevel, setZoomLevel] = useState(1);
  // const {
  //   clientTypeOptions: [, setClientType],
  //   facilityOptions: [, setFacilityOptions],
  //   companyOptions: [, setCompanyOptions],
  // } = useMainFiltersContext();

  const [params, setParams] = useState(initialParams);

  const handleFiltersChange = useCallback(
    (values: WeekViewFiltersFormValues) => {
      setParams((prevParams) => ({
        ...prevParams,
        ...values,
        date: formatDate({
          date: values.date || prevParams.date,
          format: "isoDate",
        }),
        //date:"2024-03-05",
      }));
    },
    []
    // (values: WeekViewFiltersFormValues) => {
    //   console.log(values, "values");
    //   // Add one day to the default date if it exists
    //   const defaultDate = values.date ? dayjs(values.date).add(1, 'day') : null;

    //   setParams((prevParams) => ({
    //     ...prevParams,
    //     ...values,
    //     date: formatDate({
    //       date: defaultDate || prevParams.date, // Use the modified date or previous date
    //       format: 'isoDate',
    //     }),
    //   }));
    // },
    // [],
  );

  const handleMainFiltersChange = (mainParams: MainFiltersParams) => {
    setParams((prevParams) => ({
      ...prevParams,
      company_type: permissions?.companyType.select
        ? mainParams?.company_type
        : undefined,
      facility_id: permissions?.facility.select
        ? mainParams?.facility_id
        : undefined,
      company_id: permissions?.company.select
        ? mainParams?.company_id
        : undefined,
      page: 1,
    }));
  };

  // const handleMainFiltersOptionChange = useMemo(() => {
  //   return (mainFiltersOptions: MainFiltersOptions) => {
  //     if (permissions?.companyType.select && mainFiltersOptions?.company_type) {
  //       setClientType(mainFiltersOptions?.company_type);
  //     }
  //     if (permissions?.facility.select && mainFiltersOptions?.facility_id) {
  //       setFacilityOptions(mainFiltersOptions?.facility_id);
  //     }

  //     if (permissions?.company.select && mainFiltersOptions?.company_id) {
  //       setCompanyOptions(mainFiltersOptions?.company_id);
  //     }
  //   };
  // }, [
  //   permissions?.company.select,
  //   permissions?.companyType.select,
  //   permissions?.facility.select,
  //   setClientType,
  //   setCompanyOptions,
  //   setFacilityOptions,
  // ]);

  useLayoutEffect(() => {
    if (timetableRef.current) {
      setComponentTopOffset(timetableRef.current.offsetTop);
    }
  }, []);

  const formId = "week-view-filters-form";

  const payload = {
    id: params.id,
    sport_id: params.sport_id,
    field_id: params.field_id,
    date: params.date,
  };

  const { data, isError, isFetching, isLoading, status, fetchStatus } =
    useGetFieldBookings(payload, { enabled: !!params.id });

  useEffect(() => {
    if (data) {
      setSelectedFieldTitle(`${data.name} (${data?.facility?.name})`);
    }
  }, [data]);

  const showEmptyState =
    (isLoading && fetchStatus !== "idle") || !data || !params.id;

  return (
    <>
      <ContentTopBar
        title={t("weekView.heading")}
        setZoomLevel={setZoomLevel}
        ctFilter={
          <ContentFilters formId={formId}>
            <WeekViewFiltersForm
              formId={formId}
              handleFilter={handleFiltersChange}
              initialValues={initialParams}
              facilityId={params.facility_id}
            />
          </ContentFilters>
        }
        // renderHeadingContent={
        //   <MainFilters
        //     onChange={handleMainFiltersChange}
        //     // onOptionsChange={handleMainFiltersOptionChange}
        //   />
        // }
        renderHeadingContent={
          <>
            <MainFilters onChange={handleMainFiltersChange} />
          </>
        }
      />

      {/* <ContentFilters formId={formId}>
        <WeekViewFiltersForm
          formId={formId}
          handleFilter={handleFiltersChange}
          initialValues={initialParams}
          facilityId={params.facility_id}
        />
      </ContentFilters> */}

      <div className="pgtl_zmbtn">
        <div>
          {selectedFieldTitle && !showEmptyState && (
            <SportList label={selectedFieldTitle} sports={data?.sports} />
          )}
        </div>

        <div className="mzbtngrp">
          <Button
            className="btn"
            onClick={() => setZoomLevel((z) => Math.min(2, z + 0.1))}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"></path>
            </svg>
            <span className="ttlNm">Zoom In</span>
          </Button>
          <Button
            className="btn"
            onClick={() => setZoomLevel((z) => Math.max(0.5, z - 0.1))}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M5 11V13H19V11H5Z"></path>
            </svg>
            <span className="ttlNm">Zoom Out</span>
          </Button>
          <Button className="btn" onClick={() => setZoomLevel(1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M22 12C22 17.5228 17.5229 22 12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2V4C7.5817 4 4 7.58172 4 12C4 16.4183 7.5817 20 12 20C16.4183 20 20 16.4183 20 12C20 9.53614 18.8862 7.33243 17.1346 5.86492L15 8V2L21 2L18.5535 4.44656C20.6649 6.28002 22 8.9841 22 12Z"></path>
            </svg>
            <span className="ttlNm">Reset Zoom</span>
          </Button>
        </div>
      </div>

      <StyledTimetableBackground className="slot_wrap week_view_clg">
        <div>
          <TimetableContainer
            className="slot_cell"
            ref={timetableRef}
            $offset={componentTopOffset}
            status={!data ? "empty" : isFetching ? "loading" : status}
            headerHeight={50}
          >
            {isFetching ? (
              <Loader />
            ) : isError ? (
              <ResultError />
            ) : showEmptyState ? (
              <EmptyStateWrapper>
                <Empty description={<>{t("weekView.empty")}</>} />
              </EmptyStateWrapper>
            ) : (
              <WeekTimetable
                data={data}
                date={formatDate({ date: params.date, format: "isoDate" })}
                filteredSportId={params.sport_id}
                zoomLevel={zoomLevel}
              />
            )}
          </TimetableContainer>
        </div>
      </StyledTimetableBackground>
    </>
  );
};
